import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
export const RecipesContext = createContext();

const RecipeProvider = (props) => {

    const [recipes, saveRecipes] = useState([]);
    const [search, searchRecipe] = useState({
        name: '',
        category: ''
    });

    const [consult, getConsult] = useState(false);

    const { name, category } = search;

    useEffect(() => {
        if (consult) {
            const getRecipes = async () => {
                const url = `https://www.thecocktaildb.com/api/json/v1/1/filter.php?i=${name}&c=${category}`;
                const result = await axios.get(url);
                console.log(url);
                saveRecipes(result.data.drinks);
            }
            getRecipes();
        }
        // eslint-disable-next-line
    }, [search]);

    return (
        <RecipesContext.Provider
            value={{
                recipes,
                searchRecipe,
                getConsult
            }}
        >
            {props.children}
        </RecipesContext.Provider>
    )
}

export default RecipeProvider;